export default "__VITE_ASSET__1CjOwlDR__"